var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPeltp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 371,
    height: 371,
    viewBox: "0 0 371 371",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.5 254.138C194.169 254.138 201.196 261.158 201.196 269.816C201.196 325.23 156.219 370.155 100.742 370.155C92.0737 370.155 85.0464 363.136 85.0464 354.477C85.0464 345.819 92.0737 338.799 100.742 338.799C138.882 338.799 169.804 307.913 169.804 269.816C169.804 261.158 176.831 254.138 185.5 254.138Z",
    fill: "#D9FFD8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.5 116.172C176.831 116.172 169.804 109.153 169.804 100.494C169.804 45.0805 214.781 0.155291 270.258 0.155295C278.926 0.155296 285.954 7.17456 285.954 15.8333C285.954 24.492 278.926 31.5112 270.258 31.5112C232.118 31.5112 201.196 62.3979 201.196 100.494C201.196 109.153 194.169 116.172 185.5 116.172Z",
    fill: "#D9FFD8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.954 354.477C285.954 363.136 278.926 370.155 270.258 370.155C214.781 370.155 169.804 325.23 169.804 269.816C169.804 261.158 176.831 254.138 185.5 254.138C194.169 254.138 201.196 261.158 201.196 269.816C201.196 307.913 232.118 338.799 270.258 338.799C278.926 338.799 285.954 345.819 285.954 354.477Z",
    fill: "#D9FFD8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.0464 15.8332C85.0464 7.17453 92.0737 0.155272 100.742 0.155273C156.219 0.155283 201.196 45.0805 201.196 100.494C201.196 109.153 194.169 116.172 185.5 116.172C176.831 116.172 169.804 109.153 169.804 100.494C169.804 62.3979 138.882 31.5112 100.742 31.5112C92.0737 31.5112 85.0464 24.4919 85.0464 15.8332Z",
    fill: "#D9FFD8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9845 0.155273C24.6531 0.155275 31.6804 7.17454 31.6804 15.8332V100.494C31.6804 109.153 24.6531 116.172 15.9845 116.172C7.31589 116.172 0.288618 109.153 0.28862 100.494V15.8332C0.288622 7.17453 7.31592 0.155272 15.9845 0.155273Z",
    fill: "#D9FFD8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M355.015 254.138C363.684 254.138 370.711 261.158 370.711 269.816V354.477C370.711 363.136 363.684 370.155 355.015 370.155C346.347 370.155 339.319 363.136 339.319 354.477V269.816C339.319 261.158 346.347 254.138 355.015 254.138Z",
    fill: "#D9FFD8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9845 370.155C7.31589 370.155 0.288647 363.136 0.288651 354.477L0.288681 269.816C0.288685 261.158 7.31598 254.138 15.9846 254.138C24.6532 254.138 31.6804 261.158 31.6804 269.816L31.6804 354.477C31.6804 363.136 24.6531 370.155 15.9845 370.155Z",
    fill: "#D9FFD8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M355.015 116.172C346.347 116.172 339.319 109.153 339.319 100.494L339.32 15.8332C339.32 7.17454 346.347 0.155277 355.015 0.155281C363.684 0.155284 370.711 7.17455 370.711 15.8333L370.711 100.494C370.711 109.153 363.684 116.172 355.015 116.172Z",
    fill: "#D9FFD8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.28862 185.155C0.28862 176.497 7.31592 169.477 15.9845 169.477H100.742C109.411 169.477 116.438 176.497 116.438 185.155C116.438 193.814 109.411 200.833 100.742 200.833H15.9845C7.31592 200.833 0.28862 193.814 0.28862 185.155Z",
    fill: "#D9FFD8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.562 185.155C254.562 176.497 261.589 169.477 270.258 169.477H355.015C363.684 169.477 370.711 176.497 370.711 185.155C370.711 193.814 363.684 200.833 355.015 200.833H270.258C261.589 200.833 254.562 193.814 254.562 185.155Z",
    fill: "#D9FFD8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.0464 269.816C85.0464 261.158 92.0737 254.138 100.742 254.138L270.258 254.138C278.926 254.138 285.954 261.158 285.954 269.816C285.954 278.475 278.926 285.494 270.258 285.494H100.742C92.0737 285.494 85.0464 278.475 85.0464 269.816Z",
    fill: "#D9FFD8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.954 100.494C285.954 109.153 278.926 116.172 270.258 116.172H100.742C92.0737 116.172 85.0464 109.153 85.0464 100.494C85.0464 91.8355 92.0737 84.8163 100.742 84.8163H270.258C278.926 84.8163 285.954 91.8355 285.954 100.494Z",
    fill: "#D9FFD8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeltp);
export default __webpack_public_path__ + "static/media/PELTP.311486dc52c6ff2ac41da16ae9bb2528.svg";
export { ForwardRef as ReactComponent };